module.exports = __webpack_public_path__ + "img/logo-generalitat.c773fd53.png";